import { createContext, useContext } from 'react';

import type { TInitContext } from '~/src/features/videocontrol/Provider/types';

export const RequisitionContext = createContext({} as TInitContext);

export const useRequisitionContext = () => {
    return useContext(RequisitionContext);
};
